import { render } from "./footer.vue?vue&type=template&id=d3c71564&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=d3c71564&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c71564"]])

export default __exports__